module.exports = __webpack_public_path__ + "img/ss1.3eb789b3.png";